import { ILanguageOptionsAvailable } from "src/context/Translations/interface";

enum SocketPaths{
    LOAD_NOTIFICATIONS = 0
}

export interface ISocketReturnData{
    path: SocketPaths;
    data: any;
}

export enum MessageOrigin{  
    UNDEFINED = 0,
    ACTION = 1,
    MEETING = 2,
    INDICATOR = 3,
    PROJECT = 4,
    OCCURRENCE = 5,
    OKR = 6,
    MAP = 7,
    FINANCIAL_MANAGEMENT = 8,
    AUDIT = 9,
    RISK = 10,
    ANALYSIS = 11,
    SWOT_ANALYSIS = 12,
    ANALYSIS_MARKET_SHARE = 13,
    SUGGESTIONS = 14,
    CONTRACTS = 15
}

export enum MessageType{  
    SUCCESS = 1,
    INFO = 2,
    WARNING = 3,
    ERROR = 4 
}

export interface NotificationDTO{  
    id: number;
    userImage: string | null;
    userName: string;
    companyId: number | null;
    companyName: string;
    group: number;
    message: string;
    fullMessage: string;
    isRead: boolean;
    type: MessageType;
    origin: MessageOrigin;
    originId: number | null;
    dateCreated: Date;
    isSystem: boolean;
}

export interface INotificationResponse{
    notifications: NotificationDTO[];
    total: number;
    unread: number;
}

export interface INotificationCard{
    notification: NotificationDTO;
    toggleRead: (id: number, isRead: boolean, isSystem: boolean) => void;
    openSystemNotification: (notificationDTO: NotificationDTO) => void;
    closeDrawer: () => void;
}

export interface INotificationsMessage{
    text: string;
    binds: any;
}

export type INotificationsSystemMessage = {
    [key in ILanguageOptionsAvailable]: string;
};

export default SocketPaths;
